export default {
    methods: {
        toggleRemember: function () {
            var code = this.tripData.code;
            if(code) {
                // make sure we have an array in our local storage
                if (!('travel-list' in window.localStorage)) {
                    window.localStorage['travel-list'] = '';
                }
                if (this.isRemembered) {
                    // remove code
                    window.localStorage['travel-list'] = window.localStorage['travel-list'].replace(code + ',', '');
                    this.isRemembered = false;
                } else {
                    // add code
                    window.localStorage['travel-list'] += code + ',';
                    this.isRemembered = true;
                }
            }
            setCartState();
        }
    },
    mounted() {
        var code = this.tripData.code;
        if(window.localStorage['travel-list']){
            var rememberedTravels = window.localStorage['travel-list'].split(',').filter(function (item) {
                return item.length != 0
            });
            if (rememberedTravels.includes(code)) this.isRemembered = true;
        }
    },
};